export function createFocusHistory(initialFocusId = null) {
  return { entries: [initialFocusId || null], index: 0 };
}

export function pushFocusHistory(history, focusId) {
  const current = history || createFocusHistory();
  const nextFocusId = focusId || null;
  if (current.entries[current.index] === nextFocusId) return current;
  const entries = current.entries.slice(0, current.index + 1);
  entries.push(nextFocusId);
  return { entries, index: entries.length - 1 };
}

export function stepFocusHistory(history, direction) {
  const current = history || createFocusHistory();
  const index = Math.max(0, Math.min(current.entries.length - 1, current.index + direction));
  return index === current.index ? current : { ...current, index };
}

export function currentFocusId(history) {
  return history?.entries?.[history.index] || null;
}

export function pruneFocusHistory(history, removedNodeIds) {
  const current = history || createFocusHistory();
  const removed = removedNodeIds instanceof Set ? removedNodeIds : new Set(removedNodeIds || []);
  const entriesThroughCurrent = current.entries
    .slice(0, current.index + 1)
    .filter((focusId) => !focusId || !removed.has(focusId));
  const entries = current.entries.filter((focusId) => !focusId || !removed.has(focusId));
  if (!entries.length) return createFocusHistory();
  return {
    entries,
    index: Math.max(0, entriesThroughCurrent.length - 1),
  };
}
